export default __webpack_public_path__ + "static/media/boxer.9e222523.jpg";